import { Dropdown, Icon, Menu, theme } from "@findemdev/maui";
import { CredentialLibraryType, CredRef, ICredential } from "../../../types/credential";
import { ItemContainer } from "./CredentialsTable.styled";
import { EditDetailsModal } from "./CredentialsTable";
import { useIsUserCredOwner } from "../../../hooks/useIsUserCredOwner";
import { TabId } from "../NavigationTabs";
import { decodeString } from "@findemdev/findem-helpers";
import { useContext } from "react";
import UserContext from "../../../../../contexts/UserContext";

interface IActionProps {
  setDeleteCredModal: React.Dispatch<React.SetStateAction<{
    show: boolean;
    credRef: CredRef | null;
  }>>;
  setEditDetailsModal: React.Dispatch<React.SetStateAction<EditDetailsModal>>;
  setCopyCredModal: React.Dispatch<React.SetStateAction<{
    show: boolean;
    newCredName: string;
    credential: ICredential | null;
  }>>;
  setMarqueeCredModal: React.Dispatch<React.SetStateAction<{
    show: boolean;
    credential: ICredential | null;
  }>>;
  credRef: CredRef;
  credential: ICredential;
  activeTab: TabId;
}

const Action = ({
  setDeleteCredModal,
  setEditDetailsModal,
  setCopyCredModal,
  setMarqueeCredModal,
  credential,
  credRef,
  activeTab,
}: IActionProps) => {
  const isUserCredOwner = useIsUserCredOwner({ credentialParam: credential });
  const userModel = useContext(UserContext);

  const isMarqueeCred = credential.libraries?.includes(CredentialLibraryType.MARQUEE_LIBRARY);

  const isFavoritesTab = activeTab === TabId['favorites'];
  const isCredShared = activeTab === TabId['cred-library'] || activeTab === TabId['marquees']; // only credentials which are shared with others show up in these tabs
  const isSharedInFavorites = isFavoritesTab && !isUserCredOwner; // user can also see shared credentials in favorites tab if someone has favorited them

  const menu = <Menu onClick={(ev) => {
    ev.domEvent.stopPropagation();

    const key = ev.key;

    if (key === 'delete') {
      setDeleteCredModal({
        show: true,
        credRef: credRef
      });
    } else if (key === 'edit-details') {
      setEditDetailsModal({
        show: true,
        credential
      })
    } else if (key === 'make-a-copy') {
      setCopyCredModal({
        show: true,
        credential,
        newCredName: `${decodeString(credential.name)} (Copy)`
      });
    } else if (key === 'marquee') {
      setMarqueeCredModal({
        show: true,
        credential
      });
    }
  }}>
    {(isCredShared || isSharedInFavorites) &&
      <Menu.Item key="make-a-copy">
        <ItemContainer className="credential-action-make-a-copy">
          <Icon icon="content_copy" $color={theme.colors['grey-500']} $size={20} />Make a Copy
        </ItemContainer>
      </Menu.Item>
    }
    {(isUserCredOwner || userModel.isCredAdmin()) &&
      <Menu.Item key="edit-details">
        <ItemContainer className="credential-action-edit-details">
          <Icon icon="edit" $color={theme.colors['grey-500']} $size={20} />Edit details
        </ItemContainer>
      </Menu.Item>
    }
    {isUserCredOwner &&
      <Menu.Item key="delete">
        <ItemContainer className="credential-action-delete">
          <Icon icon="delete" $color={theme.colors['grey-500']} $size={20} />Delete
        </ItemContainer>
      </Menu.Item>
    }
    {(userModel.isCredAdmin() && (isCredShared || isFavoritesTab)) &&
      <Menu.Item key="marquee">
        <ItemContainer className="credential-action-marquee">
          <Icon icon={isMarqueeCred ? "bookmark_remove" : "collections_bookmark"} $color={theme.colors['grey-500']} $size={20} />
          {isMarqueeCred ? 'Unmark as Marquee' : 'Mark as Marquee'}
        </ItemContainer>
      </Menu.Item>
    }
  </Menu>

  return (
    <Dropdown overlay={menu} trigger={['click']} className="credential-action">
      <Icon
        icon="more_vert"
        $size={24}
        $color="#8A8A8A"
        style={{ cursor: 'pointer' }}
      />
    </Dropdown>
  );
};

export default Action;
